import { createStore, applyMiddleware, compose } from "redux";
import appReducer from "./reducers";
import thunk from "redux-thunk";

import folderPersist from "./middlewares/folder-persist";

import pubSub from "utils/pub-sub";
import * as authActions from "store/actions/authActions";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = (state, action) => {
  // reset store when logout
  if (action.type === authActions.LOGOUT) {
    state = {
      auth: state.auth,
      ui: {
        theme: state.ui.theme,
        policie: state.ui.policie
      }
    };
  }
  return appReducer(state, action);
};

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, folderPersist))
);

pubSub.on("denied", response => {
  const isAuthError =
    response?.data?.message === "Authorization required" ||
    response?.data?.message === "ERR_AUTHORIZATION_REQUIRED" ||
    response?.data?.message === "API key expired" ||
    response?.data?.message === "API key not found";

  if (isAuthError) {
    store.dispatch(authActions.handleSessionTimeout());
  } else {
    store.dispatch(authActions.resetSession(false));
  }
});

pubSub.on("passwordChange", () => {
  store.dispatch(authActions.setRenewRequired(true));
});

export default store;
